// Wellness tab: three tiles, 1-5 pickers, history bars.
import React, { useState } from 'react';
import ScorePicker from './ScorePicker';
import { daysAgoText, daysSince, fmtMonDay } from '../../../lib/conciergeActivityModel';
import { latestScores, scoreTone, barTone, trendText, WELLNESS_STALE_DAYS } from '../../../lib/conciergeAttentionModel';

function Tile({ label, value, tone, sub }) {
  return (
    <div className="cn-card cn-tile">
      <div className="cn-tile__label">{label}</div>
      <div className={`cn-tile__value cn-tone--${tone || 'ink'}`}>{value}</div>
      <div className="cn-tile__sub">{sub}</div>
    </div>
  );
}

export default function WellnessTab({ checks, onSave }) {
  const [mental, setMental] = useState(0);
  const [sleep, setSleep] = useState(0);
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const now = new Date();
  const last = checks?.[0];
  const s = latestScores(checks || []);
  const stale = last ? daysSince(last.created_at, now) > WELLNESS_STALE_DAYS : true;
  const empty = !mental && !sleep && !notes.trim();
  const save = () => {
    if (empty) return;
    setSaving(true);
    onSave({ mental_score: mental || null, sleep_score: sleep || null, notes: notes.trim() || null })
      .then(() => { setMental(0); setSleep(0); setNotes(''); })
      .catch(() => {}) // the page shows the error; keep the draft
      .finally(() => setSaving(false));
  };
  return (
    <div className="cn-tabbody">
      <div className="cn-tiles">
        <Tile label="Last wellness check-in" value={daysAgoText(last?.created_at, now)} tone={stale ? 'red' : 'ink'}
          sub={last ? `${fmtMonDay(last.created_at)} · ${last.author_name || '—'}` : 'None logged yet'} />
        <Tile label="Latest mental" value={s.mental ? `${s.mental.value} / 5` : '—'}
          tone={s.mental ? scoreTone(s.mental.value) : 'ink'} sub={trendText(s.mental)} />
        <Tile label="Latest sleep" value={s.sleep ? `${s.sleep.value} / 5` : '—'}
          tone={s.sleep ? scoreTone(s.sleep.value) : 'ink'} sub={trendText(s.sleep)} />
      </div>
      <div className="cn-wellness-grid">
        <section className="cn-card">
          <div className="cn-card__head"><h2 className="cn-card__title">New check-in</h2></div>
          <div className="cn-wellness-form">
            <ScorePicker label="Mental" value={mental} onChange={setMental} />
            <ScorePicker label="Sleep" value={sleep} onChange={setSleep} />
            <textarea className="cn-textarea" rows={3} placeholder="Notes on mental state / sleep…"
              value={notes} onChange={e => setNotes(e.target.value)} />
            <button type="button" className="cn-pbtn" onClick={save} disabled={saving || empty}>Save check-in</button>
          </div>
        </section>
        <section className="cn-card">
          <div className="cn-card__head"><h2 className="cn-card__title">History</h2></div>
          {(checks || []).length === 0 ? <div className="cn-empty-line">No check-ins yet.</div>
            : checks.map(c => (
              <div key={c.id} className="cn-row cn-whist">
                <div><div className="cn-whist__date">{fmtMonDay(c.created_at)}</div>
                  <div className="cn-whist__by">{c.author_name}</div></div>
                <div className="cn-whist__bars">
                  {[['Mental', c.mental_score], ['Sleep', c.sleep_score]].map(([k, v]) => (
                    <div key={k} className="cn-whist__bar">
                      <span className="cn-whist__k">{k}</span>
                      <span className="cn-whist__track">
                        {v != null && <span className={`cn-whist__fill cn-bar--${barTone(v)}`} style={{ width: `${v * 20}%` }} />}
                      </span>
                    </div>
                  ))}
                </div>
                <div className="cn-whist__note">{c.notes}</div>
              </div>
            ))}
        </section>
      </div>
    </div>
  );
}
